import { Page } from "components/Page";

import "react-tabulator/css/bootstrap/tabulator_bootstrap.min.css";
import "react-tabulator/lib/styles.css";

import { Outlet } from "react-router-dom";

const ALILogsView = () => {
  return (
    <Page title="ALI Logs" parentRoute="/ali-logs" label="ALI Logs">
      <Outlet />
    </Page>
  );
};

export default ALILogsView;
